'use strict';
const News = {
    el: null,
    NB_ELEM_PER_PAGE: 8,
    init: function () {
        News.el = document.querySelector('.t-news');

        if (News.el) {
            News.currentFiltre = {};
            News.url = api?.["news-list"];

            News.form = document.querySelector('.t-news form');
            News.fullbox = document.querySelector(".t-news__articles");
            News.fullbox.addEventListener("transitionend", e => {
                if (News.fullbox.timeOut) {
                    clearTimeout(News.fullbox.timeOut);
                }
                News.fullbox.timeOut = setTimeout(() => {
                    let aItems = News.fullbox.querySelectorAll("*[class*='anim-delay']");
                    aItems.forEach(aItem => {
                        const classes = aItem.className.split(' ');
                        const newClasses = classes.filter(cls => !cls.startsWith('anim-delay'));
                        aItem.className = newClasses.join(' ');
                    })
                }, 1000);
            })

            News.box = document.querySelector(".t-news__liste");
        }

        if (News.el && News.form && News.url) {
            News.allSubListe = document.querySelectorAll(".t-news__subcat__liste");
            News.allSubButton = document.querySelectorAll(".t-news__subcat__button");
            News.allSelect = document.querySelectorAll(".t-news__select select");

            News.initURL();

            News.catItem = document.querySelectorAll(".t-news__cat__item");
            News.catItem.forEach(item => {
                item.button = item.querySelector(".t-news__cat__button");

                if (item.button) {
                    item.subliste = item.querySelector(".t-news__subcat__liste");

                    item.button.addEventListener("click", e => {
                        e.preventDefault();

                        News.allSubListe.forEach(subliste => {
                            if (subliste === item.subliste) {
                                subliste.classList.toggle("visible");
                                subliste.parentElement.classList.toggle("visible");
                            } else {
                                subliste.classList.remove("visible");
                                subliste.parentElement.classList.remove("visible");
                            }
                        })
                    })
                }
            })

            News.allSubButton = document.querySelectorAll(".t-news__subcat__button");
            News.allSubButton.forEach(btn => {
                btn.addEventListener("click", e => {
                    e.preventDefault();
                    btn.classList.toggle("selected");

                    let name = btn.dataset.name;
                    let value = btn.dataset.value;

                    News.updateObjectFiltre(name, value, btn.classList.contains("selected"))

                    News.updateURL();

                    News.currentPage = 1;
                    News.loadNews();
                })
            })

            News.clearButton = document.querySelector(".t-news__cat__link");
            if (News.clearButton) {
                News.clearButton.addEventListener("click", e => {
                    e.preventDefault();
                    News.currentFiltre = {};
                    News.updateURL();
                    News.allSubButton.forEach(btn => btn.classList.remove("selected"));
                    News.allSelect.forEach(select => {
                        select.selectedIndex = 0;
                        select.customSelect.value = select.options[select.selectedIndex].value;
                    });

                    News.currentPage = 1;
                    News.loadNews();
                })
            }

            News.allSelect.forEach(select => {
                select.addEventListener("change", e => {
                    e.preventDefault();
                    News.updateObjectFiltre(select.name, select.value, false, true);

                    News.updateURL();

                    News.currentPage = 1;
                    News.loadNews();
                })
            })

            News.current = document.querySelector(".t-news__current");
            News.total = document.querySelector(".t-news__total");
            News.loadMore = document.querySelector(".t-news__loadmore");
            if (News.loadMore) {
                News.loadMore.addEventListener("click", e => {
                    News.currentPage++;
                    News.loadNews();
                })
            }

            News.currentPage = 1;
            News.loadNews();
        }
    },

    updateObjectFiltre(name, value, isSelected, doReplace = false) {
        if (!News.currentFiltre[name]) {
            News.currentFiltre[name] = [];
        }

        if (!doReplace) {
            if (isSelected && News.currentFiltre[name].indexOf(value) === -1) {
                News.currentFiltre[name].push(value);
            } else if (!isSelected && News.currentFiltre[name].indexOf(value) > -1) {
                News.currentFiltre[name].splice(News.currentFiltre[name].indexOf(value), 1);
            }
        } else {
            News.currentFiltre[name] = value === "0" ? [] : [value];
        }

        if (News.currentFiltre[name].length === 0) {
            delete News.currentFiltre[name];
        }
    },

    updateURL: function () {
        let hash = "";

        if (Object.keys(News.currentFiltre).length > 0) {
            let filtres = JSON.stringify(News.currentFiltre);
            hash = encodeURI(filtres)
        }

        document.location.hash = hash;
    },

    initURL: function () {
        let hash = document.location.hash;
        let filtres = decodeURI(hash);

        if (filtres[0] === "#") {
            filtres = filtres.substring(1);
        }

        try {
            News.currentFiltre = JSON.parse(filtres);
        }
        catch {
        }

        for (let name in News.currentFiltre) {
            News.currentFiltre[name].forEach(value => {
                let button = [...News.allSubButton].filter(btn => btn.dataset.value === value && btn.dataset.name === name);
                if (button.length > 0) {
                    button[0].classList.add("selected");
                } else {
                    let select = [...News.allSelect].filter(select => select.name === name);
                    if (select.length > 0) {
                        let tSelect = select[0];

                        for (let i = 0; i < tSelect.options.length; i++) {
                            if (tSelect.options[i].value === value) {
                                tSelect.selectedIndex = i;
                                if (tSelect.customSelect) {
                                    tSelect.customSelect.value = value;
                                }
                            }
                        }
                    }
                }
            })
        }
    },

    loadNews: function () {

        let formData = new FormData();

        for (let name in News.currentFiltre) {
            if (name !== "year" && name != "order") {
                News.currentFiltre[name].forEach(value => {
                    formData.append(name + "[]", value)
                });
            } else {
                formData.append(name, News.currentFiltre[name][0])
            }
        }

        formData.append("page", News.currentPage);
        formData.append("posts_per_page", News.NB_ELEM_PER_PAGE);

        let fnews = News.box.querySelectorAll(".f-news");
        [...fnews].forEach(child => child.classList.add("forcedAnim"))

        fetch(News.url,
            {
                method: "POST",
                body: formData
            }
        )
            .then(response => response.json())
            .then(json => {

                if (json?.items) {
                    if (News.currentPage === 1) {
                        News.box.innerHTML = "";
                    }

                    let start = (News.currentPage - 1) * News.NB_ELEM_PER_PAGE;

                    News.fullbox.classList.remove("doAnim");
                    let index = 0;

                    for (let i = 0; i < json.items.length; i++) {
                        let data = json.items[i];
                        if (start + i === 0) {
                            News.mainCol = document.createElement("div");
                            News.mainCol.classList.add("f-newsinsights__cols");
                            News.box.appendChild(News.mainCol);

                            let infos = News.getItem(data.permalink, data.image?.url, data.category, data.suptitle, data.title, data.image?.alt, index);
                            index = infos[1];
                            let article = infos[0];

                            News.mainCol.innerHTML = `<div class="f-newsinsights__col f-newsinsights__col--main"></div>`;
                            News.mainCol.querySelector(".f-newsinsights__col--main").appendChild(article);
                        } else if (start + i === 1) {
                            News.secondCol = document.createElement("div");
                            News.secondCol.classList.add("f-newsinsights__col");
                            News.secondCol.classList.add("f-newsinsights__col--news");
                            News.secondCol.classList.add("f-newsinsights__col--news2");
                            News.mainCol.appendChild(News.secondCol);

                            let infos = News.getItem(data.permalink, data.image?.url, data.category, data.suptitle, data.title, data.image?.alt, index);
                            index = infos[1];
                            News.secondCol.appendChild(infos[0]);
                        } else if (start + i === 2) {
                            let infos = News.getItem(data.permalink, data.image?.url, data.category, data.suptitle, data.title, data.image?.alt, index);
                            index = infos[1];
                            News.secondCol.appendChild(infos[0]);
                        } else if (start + i === 3) {
                            News.lastCol = document.createElement("div");
                            News.lastCol.classList.add("t-news__othercols");
                            News.box.appendChild(News.lastCol);

                            let infos = News.getItem(data.permalink, data.image?.url, data.category, data.suptitle, data.title, data.image?.alt, index);
                            index = infos[1];
                            News.lastCol.appendChild(infos[0]);
                        } else {
                            let infos = News.getItem(data.permalink, data.image?.url, data.category, data.suptitle, data.title, data.image?.alt, index);
                            index = infos[1];
                            News.lastCol.appendChild(infos[0]);
                        }
                    }

                    if (News.current && News.total) {
                        let totalElements = json.total;
                        let currentElements = (News.currentPage - 1) * News.NB_ELEM_PER_PAGE + json.items.length

                        if (currentElements >= totalElements) {
                            currentElements = totalElements;
                            News.loadMore.classList.add("hidden");
                        } else {
                            News.loadMore.classList.remove("hidden");
                        }

                        News.current.innerHTML = currentElements;
                        News.total.innerHTML = totalElements;
                    }

                    setTimeout(() => {
                        News.fullbox.classList.add("doAnim");
                        News.el.classList.add("loaded");
                    }, 10);
                }
            });
    },

    getItem(link, visuel, category, date, titre, alt, index) {
        let categoryStr = "";
        if (category) {
            categoryStr = `<span class="f-news__type">${category.map(cat => cat.name).join(", ")}</span><span class="f-news__sep"></span>`
        }

        let imageStr = "";
        if (visuel !== "" && visuel !== undefined) {
            imageStr = `<div class="f-news__visuel image-path anim-delay${++index}"><img src="${visuel}" alt="${alt}"></div>`;
        } else{
            imageStr = `<div class="f-news__visuel image-path anim-delay${++index}"><img src="data:image/png;base64,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" alt=""></div>`;
        }

        let item = document.createElement("a");
        item.classList.add("f-news");
        item.href = link;

        item.innerHTML = `
            ${imageStr}
            <div class="f-news__infos fade-slide-in anim-delay${++index}">
                ${categoryStr}<span class="f-news__date">${date}</span>
            </div>
            <p class="f-news__titre fade-slide-in anim-delay${++index}">${titre}</p>
        `


        return [item, index]
    }
};

export default News;